'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InputGroupAddon = require('./InputGroupAddon');

var _InputGroupAddon2 = _interopRequireDefault(_InputGroupAddon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _InputGroupAddon2["default"];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/bee-input-group-addon/build/index.js
// module id = 504
// module chunks = 0